import type { FabrikODataFieldType } from '../../types/apps';

const parseDateValue = (value: unknown): Date => {
  if (typeof value !== 'string') {
    throw new Error('An OData date/time filter requires a string value.');
  }

  const sapDate = /^\/Date\((-?\d+)(?:[+-]\d{4})?\)\/$/.exec(value);
  const dateOnly = /^\d{4}-\d{2}-\d{2}$/.test(value);
  const date = new Date(sapDate ? Number(sapDate[1]) : dateOnly ? `${value}T00:00:00Z` : value);
  if (!Number.isFinite(date.getTime()) || (dateOnly && date.toISOString().slice(0, 10) !== value)) {
    throw new Error('OData date/time filters require a valid ISO or SAP date value.');
  }
  return date;
};

const odataDateTimeLiteral = (
  value: unknown,
  fieldType: 'Edm.DateTime' | 'Edm.DateTimeOffset'
): string => {
  const iso = parseDateValue(value).toISOString();
  return fieldType === 'Edm.DateTime'
    ? `datetime'${iso.slice(0, -1).replace(/\.000$/, '')}'`
    : `datetimeoffset'${iso.replace(/\.000Z$/, '+00:00').replace(/Z$/, '+00:00')}'`;
};

export const odataLiteral = (value: unknown, fieldType?: FabrikODataFieldType): string => {
  if (value === null) return 'null';
  if (fieldType === 'Edm.DateTime' || fieldType === 'Edm.DateTimeOffset') {
    return odataDateTimeLiteral(value, fieldType);
  }
  if (fieldType === 'Edm.String' && typeof value !== 'string') {
    throw new Error('An OData string filter requires a string value.');
  }
  if (typeof value === 'string') return `'${value.replace(/'/g, "''")}'`;
  if (typeof value === 'number' && Number.isFinite(value)) return String(value);
  if (typeof value === 'boolean') return String(value);
  throw new Error('A list filter requires a scalar row value.');
};
